// Libs
import { useEffect } from 'react';
import { widgetStateRequest } from './modules/messaging';
import { feedbackButtonClickEvent } from './modules/analytics';

// Hooks
import useOnMessage from './hooks/useOnMessage';

// Containers
import Map from './containers/map';
import Controlls from './containers/controlls';
import Header from './containers/header';
import ZoomControls from './components/zoom-controls';

// Components
import RateUs from './components/rate-us';

// Contexts
import { useLifeCycle } from './contexts/life-cycle.context';
import { useControlls } from './contexts/controlls.context';

// Services
import { useConfig } from './services/config';

// Config
import { appConfig } from './config/app.config';

import './app.scss';

function App() {
	const { isOpened, setIsOpened } = useLifeCycle();
	const { profile, stops } = useControlls();
	const { config, isSuccess: isConfigReady } = useConfig({ enabled: !appConfig.isWebsite });

	function onRateUsClick() {
		feedbackButtonClickEvent();
		window.open(config?.feedbackLink, '_blank');
	}

	useOnMessage(
		{
			'widget-state-changed': (isOpen: boolean) => {
				const isAlreadySet = isOpened;
				if (isOpen && !isAlreadySet) {
					setIsOpened(isOpen);
				}
			}
		},
		{ listen: !appConfig.isWebsite }
	);

	useEffect(() => {
		widgetStateRequest();
	}, []);

	return (
		<div className="app">
			{!appConfig.isWebsite && <Header />}
			{isOpened && <Map profile={profile} stops={stops} />}
			<Controlls />
			<ZoomControls />
			{isConfigReady && (
				<RateUs style={{ position: 'absolute', left: '25px', bottom: '0' }} onClick={onRateUsClick} />
			)}
		</div>
	);
}

export default App;
